<template lang="pug">
  router-view
</template>

<script>
  export default {
    beforeCreate () {
      if (this.$route.params.type === undefined) this.$router.push(`/${this.$route.path.split('/')[1]}/rent`)
    },
    watch: {
      '$route' (to, from) {
        if (this.$route.params.type === undefined) this.$router.push(`/${this.$route.path.split('/')[1]}/rent`)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?8c28bd52